import { useQuery } from "react-query";
import { ReferentialApi } from "../../api";
import { useApiService } from "../useApiService";

export function usePositionRef() {
  const api = useApiService(ReferentialApi);
  const { data, isFetching, refetch } = useQuery(
    "ref-position",
    async () => {
      return await api.positions();
    },
    { staleTime: Infinity }
  );

  return {
    positions: data ?? [],
    loading: isFetching,
    refetch: refetch,
  };
}
